// import hooks
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// import types
import { TabProps } from '../CLASettings.types';

// import components
import Grid from '@mui/material/Grid';
import withReadModeField from 'components/shared/CRUD/components/InnerPage/components/withReadModeField';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

//import utils
import { capPlanSchema } from '../CLASettings.schema';

const ControlledNumericFieldWithReadMode = withReadModeField(
  ControlledNumericField
);

const CapPlanTab = ({ setCurrentSchema }: TabProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla'
  });

  useEffect(() => {
    setCurrentSchema(capPlanSchema);
  }, []);

  return (
    <>
      <MultiStepForm.Section title={t('capReferenceNetHours')}>
        <Grid style={{ maxWidth: '32%' }}>
          <ControlledNumericFieldWithReadMode
            name={'capReferenceNetHours'}
            label={t('averageReference')}
            variant={'outlined'}
          />
        </Grid>
      </MultiStepForm.Section>
    </>
  );
};

export default CapPlanTab;
